// Б.1.d: Сквилл passive (часть 2).
// «Начинает с 2 случайными модификациями ИЗ КОЛОДЫ в руке (сверх лимита изначального)».
// Применяется один раз — после раздачи стартовой руки в createMatch.
// Бонусные карты помечаются card.skvillBonus=true и не замешиваются в мулигане.

export const HERO_ID = 'syn_skvill';

export function applySkvillStartingMods(player, rng, log) {
  if (!player || player.hero?.id !== HERO_ID) return;
  const modsInDeck = player.deck.filter(c => c.type === 'mod');
  if (modsInDeck.length === 0) {
    log.add(`✨ Сквилл [${player.name}]: в колоде нет Модов для стартовой руки`);
    return;
  }
  const pickCount = Math.min(2, modsInDeck.length);
  // Случайный без повторов: вытягиваем по индексу из copy и удаляем.
  const pool = [...modsInDeck];
  const picked = [];
  for (let i = 0; i < pickCount; i++) {
    const idx = rng.int(pool.length);
    const card = pool.splice(idx, 1)[0];
    const deckIdx = player.deck.indexOf(card);
    if (deckIdx >= 0) player.deck.splice(deckIdx, 1);
    card.skvillBonus = true;
    player.hand.push(card);
    picked.push(card);
  }
  if (pickCount === 1) {
    log.add(`✨ Сквилл [${player.name}]: в колоде был только 1 Мод (${picked[0].name_ru})`);
  } else {
    log.add(`✨ Сквилл [${player.name}]: +2 Мода в стартовую руку (${picked[0].name_ru}, ${picked[1].name_ru})`);
  }
}
